import React from "react";

import { TimeProps } from "./types";
import { useTime } from "./hooks";

export const Time = (props: TimeProps) => {
  const { getMsProps, getScProps, getTimeProps, values } = useTime(props);
  return (
    <div {...getTimeProps()}>
      <span {...getScProps()}>{values.sc}</span>
      <span {...getMsProps()}>{values.ms}</span>
    </div>
  );
};
